import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useLang } from './context/LanguageContext';
import Home from './pages/Home';
import './styles/global.css';

const App = () => {
  const { lang, isRTL } = useLang();

  // Apply direction, language, and font to document.body dynamically
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.body.dir = isRTL ? 'rtl' : 'ltr';
    document.body.style.fontFamily = isRTL
      ? "var(--font-ar)"
      : "var(--font-en)";
  }, [lang, isRTL]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {/* Future admin panel routes will be added here:
          <Route path="/admin/*" element={<AdminLayout />} />
          Protected with AuthContext — see src/pages/admin/README.md */}
    </Routes>
  );
};

export default App;
